export default "<a hex-link\n   [href]=\"downloadLink\"\n   download>\n  <ng-content></ng-content>\n</a>\n"